// extracted by mini-css-extract-plugin
export default {"main_container":"App_main_container__Lg-Bo","wrapper":"App_wrapper__50AJ9"};